import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../../components/AuthLayout';
import { Button } from '../../components/Button';
import { Spinner } from '../../components/Spinner';
import { useAuth } from '../../auth/AuthContext';
import { homePathForRole } from '../../lib/routes';

export function PendingScreen() {
  const { user, loading, signOut, refresh } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState<'check' | 'signout' | null>(null);
  const [error, setError] = useState('');

  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.status !== 'pending') return <Navigate to={homePathForRole(user)} replace />;

  async function checkAgain() {
    if (busy) return;
    setError('');
    setBusy('check');
    try {
      await refresh();
    } catch {
      setError('Could not check your status. Please try again.');
    } finally {
      setBusy(null);
    }
  }

  async function handleSignOut() {
    if (busy) return;
    setError('');
    setBusy('signout');
    try {
      await signOut();
      navigate('/login');
    } catch {
      setError('Could not sign out. Please try again.');
      setBusy(null);
    }
  }

  return (
    <AuthLayout
      title="Waiting for approval"
      subtitle="Your account is with the Refer Now dispatch team. You will get an email as soon as it is approved."
    >
      <div className="stack">
        {error && (
          <div className="error-banner" role="alert">
            {error}
          </div>
        )}
        <Button type="button" full disabled={busy !== null} onClick={() => void checkAgain()}>
          {busy === 'check' ? 'Checking' : 'Check again'}
        </Button>
        <Button
          type="button"
          variant="secondary"
          full
          disabled={busy !== null}
          onClick={() => void handleSignOut()}
        >
          {busy === 'signout' ? 'Signing out' : 'Sign out'}
        </Button>
      </div>
    </AuthLayout>
  );
}
